import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlay"><Path d="M21 12.0001L5.5 2.87012V21.1301L21 12.0001Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlay;
